export default __webpack_public_path__ + "static/media/5b.07a0c9c3.png";